import forge from "node-forge";

// const publicKey = process.env.REACT_APP_PUBLIC_KEY;
const publicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAtb+xYLgQfeTXBQu49zv7
UKVIjXEJna3MRYKuJBi2Vgjp6Wccun5H4SzM2PpqA+GwytTu0KGDuGG4ubSki9MY
m+As5aTWsUcAQL2KZ4gD2hWaFcvMlDe3ypxn8lpuxnPCI7PRBXt7qYUTPiESpTuI
RpHHNek+ei3FkZOT6ZvDg/VL5wCyw3E3nfuikATi4Uq2i2hIBi0Bi8dVKCc8w5Fa
Xv4nh4bGwlLQJneJocOa5MZ9RIYxiDrD2Z87E+c+1lGDRtM+5tnwugiYS8E8KPfi
hIvXeorYA70ilY/wW9GquvWOaRJUXGkgg+7/DwLfps7dUsmpezLIxQuEX2A2KeEi
gwIDAQAB
-----END PUBLIC KEY-----`;

export function encryptSha(data) {
  const publicKeyForged = forge.pki.publicKeyFromPem(publicKey);
  const encryptedDataBytes = publicKeyForged.encrypt(data, "RSA-OAEP", {
    md: forge.md.sha256.create(),
  });
  // Convert the encrypted bytes to a Base64-encoded string
  const encryptedDataBase64 = forge.util.encode64(encryptedDataBytes);
  return encryptedDataBase64;
}
